var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"80%","height":"80%"},attrs:{"id":"eventBoardId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }